module.exports = require('./helpers/bundle-url').getBundleURL('bgzEL') + "logo.c51670a8.svg";